<template>
	<div class="bg-white">
		<header class="mdc-top-app-bar top-app-bar top-header">
			<div class="mdc-top-app-bar__row">
				<!--      <section class="mdc-top-app-bar__section mdc-top-app-bar__section&#45;&#45;align-start">-->
				<!--        <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"-->
				<!--                aria-label="Open navigation menu">menu</button>-->
				<!--        <span class="mdc-top-app-bar__title t-subtitle4 pdl-12">CAMPUS NAME</span>-->
				<!--      </section>-->
			</div>
		</header>
		<div class="d-flex flex-column h-full">
			<main class="main-wrapper full flex-grow-1 h-full">
				<div class="container container--small h-full">
					<div class="h-full d-flex  justify-content-center">
						<div class="mgt-150 d-flex align-items-center   flex-column">
							<img src="@/images/idp_redirect_1.svg" alt="" class="icon200">
							<div class="mgt-4 t-headline10 font-b t-line-h-33 t-color-headlineBlack">Redirecting</div>
							<div class="mgt-8 t-body1 font-r t-line-h-21 t-color-bodyGrayA">Authentication redirect. Please wait for a moment.</div>
							<div class="mgt-200"></div>
						</div>
					</div>
				</div>
			</main>
		</div>
	
	</div>
</template>

<script>
// @ is an alias to /src
import {commonMixin} from "@/mixins/common";
import snackMessage from "@/plugins/snackMessage";
import LocalStorageUtil from "@/utils/localStorageUtil";
import localStorageUtil from "@/utils/localStorageUtil";

export default {
	name: 'LoginError',
	data() {
		return {
		
		}
	},
	
	mixins: [commonMixin],
	
	mounted() {
		let errCode = this.$route.query.errorCode;
		if (errCode === "") {
			document.location = "/";
		}
		
		errCode = Number(errCode);
		
		if (errCode === 1201) { // 관리자 승인 대기중(Waiting for administrator approval)
			// 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
			this.$alert({
				title: this.$t('779'), //가입 승인 대기 상태입니다.
				content: this.$t('780') + '<br>' + this.$t('781', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>'}) + '<br>' + this.$t('782', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>'}),
				accept: this.$t('783')
			}).then(() => {
				this.$moveIdpLogout();
			}).catch(() => {
			})
		} else if (errCode === 1202) {
			//브랜드 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
			this.$alert({
				title: this.$t('779'), //가입 승인 대기 상태입니다.
				content: this.$t('780') + '<br>' + this.$t('781', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>'}) + '<br>' + this.$t('782', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>'}),
				accept: this.$t('783')
			}).then(() => {
				this.$moveIdpLogout();
			}).catch(() => {
			})
		} else if (errCode === 1204) {
			//브랜드 관리자 승인 취소된 사용자 입니다. 관리자에게 문의해주세요.
			this.$alert({
				title: this.$t('1482'), //가입 승인 대기 상태입니다.
				content: this.$t('1483') + '<br>' + this.$t('1484') + ': ' + '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>' + '<br>' + this.$t('1485') + ': ' + '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>',
				accept: this.$t('1486')
			}).then(() => {
				this.$moveIdpLogout();
			}).catch(() => {
			})
		} else if (errCode === 1205) {
			//탈퇴 처리된 사용자 입니다. 관리자에게 문의해주세요.
			this.$alert({
				title: this.$t('1914'), //가입 승인 대기 상태입니다.
				content: this.$t('1915') + " " + this.$t('1916') + '<br>' + this.$t('1917', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>'}) + '<br>' + this.$t('1918', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>'}),
				accept: this.$t('1919')
			}).then(() => {
				this.$moveIdpLogout();
			}).catch(() => {
			})
		} else if (errCode === 1105) {
			//{}용 어플리케이션을 이용할 수 없는 계정입니다. 다시 확인해주세요.
			this.$alert({
				content: this.$t('1875'),
				accept: this.$t('1876')
			}).then(() => {
				this.$moveIdpLogout();
			}).catch(() => {
			})
		} else if (errCode === 1335) {  //아이디 계정 일시 정지(Suspend Account)
			// 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
			this.$snackOpen({contents: this.$t('323'), btnDisplayYN: false}).then(() => {
				this.$moveIdpLogout();
			})
		} else {
			this.$moveIdpLogout();
		}
	},
	
	methods: {
	
	}
}
</script>
<style>
</style>
